import React, { Suspense, lazy } from 'react';
import { withStyles } from '@material-ui/core';
import styles from './styles';
import { compose } from 'recompose';
import WithDrawer from '../../Common/Drawer/WithDrawer';
import { AppLoading } from '../../../../../loaders/loaders';
import { getTerminalOption, getStatusOption } from './utils';

const UpdateTrailer = lazy(() => import('./UpdateTrailer'));
const UpdateTractor = lazy(() => import('./UpdateTractor'));
const UpdateDolly = lazy(() => import('./UpdateDolly'));

const labelProps = ['trailerNumber', 'tractorNumber', 'dollyNumber'];

const UpdateEquipmentForm = (props) => {
  const terminalOptions = getTerminalOption(props.terminalRules, props.assetInfo.inboundTerminal);
  const renderEquipmentForm = (equipmentType) => {
    const form = {
      Trailer: (
        <UpdateTrailer
          {...props}
          key={`UpdateTrailer-${props.assetInfo.trailerStatus}`}
          terminalOptions={terminalOptions}
          statusOptions={getStatusOption(props.statusRules, props.assetInfo.trailerStatus)}
        />
      ),
      Tractor: (
        <UpdateTractor
          {...props}
          terminalOptions={terminalOptions}
          key={`UpdateTractor-${props.assetInfo.tractorStatus}`}
          statusOptions={getStatusOption(props.statusRules, props.assetInfo.tractorStatus)}
        />
      ),
      Dolly: (
        <UpdateDolly
          {...props}
          terminalOptions={terminalOptions}
          key={`UpdateDolly-${props.assetInfo.dollyStatus}`}
          statusOptions={getStatusOption(props.statusRules, props.assetInfo.dollyStatus)}
        />
      )
    };
    return form[equipmentType];
  };

  return (
    <div>
      <header className={props.classes.moduleHeader}>{`Update ${props.equipmentType} - ${
        props.assetInfo[labelProps[props.tabId]]
      }`}</header>
      <div className={props.classes.formContainer}>
        <Suspense fallback={<AppLoading />}>{renderEquipmentForm(props.equipmentType)}</Suspense>
      </div>
    </div>
  );
};

export default compose(WithDrawer, withStyles(styles))(UpdateEquipmentForm);
